module.exports = __webpack_public_path__ + "img/385.e2a8d7fe.jpg";